<template>
	<v-container fluid class="crm-index">
		<div class="custom-table-cost">
			<v-card class="budget-modal-card mb-4">
				<v-card-text class="py-2">
					<div class="d-flex justify-space-between align-start w-100">
						<div class="flex-grow-1">
							<div class="caption d-flex">
								<p class="mb-0 font-weight-bold">Configuración de Items de Costos</p>
								<v-divider vertical class="mx-2"></v-divider>
								<p class="mb-0 caption">Configura los items de costos que se utilizarán en los proyectos de la empresa (Tabla de costos).</p>
							</div>
							<div class="d-flex align-center justify-space-between">
								<div class="d-flex align-center">
									<v-select
										v-model="selectedCostCategory"
										:items="companyCostCategories"
										:menu-props="{ bottom: true, offsetY: true }"
										item-text="name"
										item-value="id"
										label="Costos"
										class="custom-height-search custom-height-calendar my-2 mr-1"
										outlined
										dense
										hide-details
										color="#959595"
										item-color="#959595"
										style="font-size: 14px; width: 300px;"
										required
										return-object
										:rules="requiredRule"
									>
										<!-- <template v-slot:item="data">
											<v-list-item-content>
												<v-list-item-title>
													<div class="d-flex align-center justify-space-between" style="max-width: 3000px">
														<p class="mb-0">{{data.item.name}}</p>
														<div class="d-flex align-center">
															<v-btn
																icon
																dark
																small
																color="warning"
																@click.stop="setCostProject(data.item)"
															>
																<v-icon small dark>mdi-pencil-outline</v-icon>
															</v-btn>
															<v-btn
																icon
																dark
																small
																color="error"
																@click.stop="deleteProject(data.item)"
															>
																<v-icon small dark>mdi-delete-outline</v-icon>
															</v-btn>
														</div>
													</div>
												</v-list-item-title>
											</v-list-item-content>
										</template> -->
									</v-select>
									<v-btn
										icon
										dark
										small
										color="#959595"
										@click="addCategory"
									>
										<v-icon dark>mdi-plus</v-icon>
									</v-btn>
								</div>
								<div class="d-flex align-center">
									<div>
										<p class="mb-0 text-right" style="font-size: 10px;line-height: 10px;">Valor UF</p>
										<p class="mb-0 font-weight-bold text-right" style="font-size: 12px;line-height: 10px;">{{ moment().format('DD-MM-YYYY') }}</p>
										<p class="mb-0 font-weight-bold text-right">${{ ufValue | toThousandFilter(2) }}</p>
									</div>
									<v-divider vertical class="mx-4"></v-divider>
									<div>
										<p class="mb-0 px-2" style="font-size: 10px;line-height: 10px;">Selecciona</p>
										<v-btn-toggle
											v-model="currency"
											color="red"
											dense
											mandatory
											borderless
										>
											<v-btn value="uf" text plain style="min-width: 30px;height:auto;" class="pa-0 font-weight-bold" small>
												UF
											</v-btn>
											<v-btn value="clp" text plain style="min-width: 30px;height:auto;" class="pa-0 font-weight-bold" small>
												CLP
											</v-btn>
										</v-btn-toggle>
									</div>
									<v-divider vertical class="mx-4"></v-divider>
									<div class="d-flex flex-column align-end">
										<CostBreakdownCompanySettings />
										<div class="d-flex align-center mt-1">
											<div class="d-flex align-center mr-2" v-if="savingConfig">
												<v-progress-circular color="#959595" :size="17" :width="2" indeterminate></v-progress-circular>
												<p class="mb-0 ml-1 caption">Guardando</p>
											</div>
											<v-btn
												depressed
												color="#FF120B"
												small
												:dark="!disableSavingButton"
												:disabled="disableSavingButton"
												@click="saveCostCategoriesConfig"
											>
												<v-icon small color="white">mdi-check</v-icon>
												<p class="mb-0 ml-2 caption">Guardar Configuración</p>
											</v-btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</v-card-text>
			</v-card>
			<div style="zoom: 90%" v-if="costBaseCategories">
				<v-simple-table>
					<tbody class="main-row caption">
						<tr class="header-rows">
							<td width="18%" rowspan="10000" class="px-1 grey lighten-3">
								<div class="d-flex flex-column align-center" style="max-width: 500px;" v-if="editCategoryName">
									<v-text-field
										v-model="costBaseCategories.name"
										label="Categoría"
										outlined
										required
										dense
										hide-details
										class="custom-height-search custom-height-calendar mb-1"
										style="font-size: 14px; width: 100%;"
										:rules="requiredRule"
									></v-text-field>
									<div class="d-flex align-center" style=" width: 100%;">
										<div class="flex-grow-1 mr-2">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														dark
														small
														color="green"
														block
														@click="createNewCategory"
														v-bind="attrs"
														v-on="on"
													>
														<v-icon small dark>mdi-check</v-icon>
													</v-btn>
												</template>
												<span>Confirmar</span>
											</v-tooltip>
										</div>
										<div>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														dark
														small
														color="red"
														@click="cancelEditCreateCategory()"
														v-bind="attrs"
														v-on="on"
													>
														<v-icon small dark>mdi-close</v-icon>
													</v-btn>
												</template>
												<span>Cancelar</span>
											</v-tooltip>
										</div>
									</div>
								</div>
								<div v-else>
									<p class="mb-0 black--text" style="font-size: 11px;font-weight: 500;">Costo</p>
									<p class="caption font-weight-bold mb-0 black--text">{{ costBaseCategories.name }}</p>
									<div class="d-flex align-center">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													icon
													dark
													x-small
													color="warning"
													@click="editCategoryName = true"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small dark>mdi-pencil</v-icon>
												</v-btn>
											</template>
											<span>Editar Categoría</span>
										</v-tooltip>
										<v-tooltip bottom v-if="costBaseCategories.id">
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													icon
													dark
													x-small
													color="error"
													@click="deleteCategory(costBaseCategories.id)"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small dark>mdi-delete-alert-outline</v-icon>
												</v-btn>
											</template>
											<span>Eliminar Categoría</span>
										</v-tooltip>
									</div>
								</div>
							</td>
							<td style="vertical-align: middle;" :width="colWidths[0]" class="text-left">
								<p class="mb-0 font-weight-bold caption">Item</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]"><p class="text-right mb-0 caption font-weight-bold" >Cantidad</p></td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]"><p class="text-right mb-0 caption font-weight-bold" >Valor U. (UF)</p></td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]"><p class="text-right mb-0 caption font-weight-bold" >Valor U. (CLP)</p></td>
							<td style="vertical-align: middle;" :width="colWidths[4]"><p class="text-right mb-0 caption font-weight-bold" >Total UF</p></td>
							<td style="vertical-align: middle;" :width="colWidths[5]"><p class="text-right mb-0 caption font-weight-bold" >Total CLP</p></td>
							<td style="vertical-align: middle;" :width="colWidths[6]"><p class="text-right mb-0 caption font-weight-bold" ></p></td>
						</tr>

						<CostItemContainer
							:costItems="costBaseCategories.items"
							:costStageType="1"
							:ufValue="ufValue"
							:colWidths="colWidths"
							:itemLevel="1"
							:currency="currency"
							@update:costItems="val => { costBaseCategories.items = val }"/>
							
					</tbody>
					<tfoot>
						<tr class="white--text" style="background: rgb(82, 77, 77);">
							<td style="vertical-align: middle;" colspan="5"><p class="text-right mb-0 font-weight-bold caption">Total</p></td>
							<td style="vertical-align: middle;" :width="colWidths[4]">
								<div>
									<p class="mb-0 text-right" >Total UF</p>
									<p class="text-right mb-0 font-weight-bold caption">{{ getValuesFromCategory(costBaseCategories).total_uf | toThousandFilter(2) }}</p>
								</div>
							</td>
							<td style="vertical-align: middle;" :width="colWidths[5]">
								<div>
									<p class="mb-0 text-right" >Total CLP</p>
								<p class="text-right mb-0 font-weight-bold caption">${{ getValuesFromCategory(costBaseCategories).total_clp | toThousandFilter }}</p>
								</div>
							</td>
							<td style="vertical-align: middle;" :width="colWidths[6]"><p class="text-right mb-0 font-weight-bold caption"></p></td>
						</tr>
					</tfoot>
				</v-simple-table>
			</div>
		</div>
	</v-container>
</template>

<script>
// import _debounce from 'lodash/debounce'
import moment from 'moment'
import CostBreakdownCompanySettings from '@/components/Views/Companies/CostBreakdownCompanySettings'
import {saveAllCostCategoriesCompanyConfig, deleteCostBaseProject, getCompanyCostCategories, setCompanyCostCategory, deleteCompanyCostCategory} from '@/helpers/api/costs'
import CostItemContainer from '@/components/Views/Projects/Parts/CostItemContainer'

export default {
	name: 'CompanyCostItemConfig',
	components: { CostBreakdownCompanySettings, CostItemContainer },
	data: () => ({
		moment,
		currency: 'uf',
		colWidths: ['30%','5%','8%','15%','10%','15%','10%'],
		editCategoryName: false,
		editBaseStage: null,
		edittingCategoryName: null,
		edittingBaseStage: null,
		selectedCostProjectId: null,
		selectedCostCategory: null,
		companyCostCategories: [],
		saveInterval: null,
		savingConfig: false,
		requiredRule: [
			v => !!v || 'Campo requerido'
		],
		costBaseCategories: null
	}),
	computed: {
		disableSavingButton(){
			if (this.savingConfig) return true;
			if (!this.costBaseCategories || !this.costBaseCategories.id) return true;
			return false;
		},
		ufValue(){
			return this.$store.state.general.dayUfValue || 40000
		},
		costCategories(){
			return this.$store.state.costbreakdown.companiesCostItems
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
	},
	watch: {
		selectedCostCategory(newValue){
			if(newValue){
				this.costBaseCategories = JSON.parse(JSON.stringify(newValue || []))
			}
		},
		selectedCompany(newValue){
			if(newValue){
				this.getCompanyCostCategoriesInfo()
			}
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.getCompanyCostCategoriesInfo()
		}
	},
	methods: {
		async getCompanyCostCategoriesInfo(){
			const categories = await getCompanyCostCategories()
			if(categories.code == 200){
				this.companyCostCategories = categories.cost_categories
				if(!this.costBaseCategories && this.companyCostCategories.length){
					this.costBaseCategories = this.companyCostCategories[0]
					this.selectedCostCategory = this.costBaseCategories
				}
			}
		},
		async createNewCategory(){
			const category = await setCompanyCostCategory(this.costBaseCategories)
			if(category.code == 200){
				this.costBaseCategories = category.cost_category
				this.getCompanyCostCategoriesInfo()
				this.cancelEditCreateCategory()
			}
		},
		setSaveInterval(){
			if(this.saveInterval){
				clearInterval(this.saveInterval)
			}
			this.saveInterval = setInterval(() => {
				this.startAutoSave()
			}, 30000)
		},
		startAutoSave(){
			if(
				this.savingConfig ||
				!this.selectedCostProjectId ||
				!this.costBaseCategories ||
				JSON.stringify(this.costBaseCategories) === JSON.stringify(this.companyCostConfig)
			) return;
			this.saveCostCategoriesConfig()
		},
		async saveCostCategoriesConfig(){
			const data = {
				company_cost_category_id: this.costBaseCategories.id,
				cost_items: this.costBaseCategories.items
			}
			if(this.selectedCostProjectId == 452){
				return
			}
			this.savingConfig = true
			await saveAllCostCategoriesCompanyConfig(data)
			this.savingConfig = false
			this.getCompanyCostCategoriesInfo()
		},
		getCleanCategories() {
			return this.costBaseCategories
				.filter(cat => cat.name && cat.name.trim() !== '')
				.map(cat => ({
					...cat,
					base_stages: cat.base_stages
						.filter(stage => stage.name && stage.name.trim() !== '')
				}))
		},
		startEditBaseStage(base_stage_id){
			this.editBaseStage = base_stage_id
			this.edittingBaseStage = this.costBaseCategories.flatMap(cat => cat.base_stages).find(bp => bp.id === base_stage_id).name
		},
		cancelEditCreateCategory(){
			this.editCategoryName = false
			this.edittingCategoryName = null
			if(!this.costBaseCategories.id){
				this.costBaseCategories = null
			}
		},
		cancelEditCreateBaseStage(base_stage, bp_index, cat_index){
			this.editBaseStage = null
			this.edittingBaseStage = null
			if(!base_stage.id){
				this.costBaseCategories[cat_index].base_stages.splice(bp_index, 1)
			}
		},
		deleteItem(item, item_index){
			this.costBaseCategories.items.splice(item_index, 1)
		},
		async deleteCategory(category_id){
			const category = await deleteCompanyCostCategory({category_id})
			if(category.code == 200){
				this.costBaseCategories = null
				this.getCompanyCostCategoriesInfo()
			}
		},
		deleteBaseStage(base_stage, bp_index, cat_index){
			if(base_stage.id){
				this.costBaseCategories[cat_index].base_stages.splice(bp_index, 1)
			}
		},
		getValuesFromCategory(category){
			return category.items.reduce(
				(acc, item) => {
					const qty = Number(item.qty) || 0;
					acc.total_uf += (Number(item.unit_cost_uf) || 0) * qty;
					acc.total_clp += (Number(item.unit_cost_clp) || 0) * qty;
					return acc;
				},
				{ total_uf: 0, total_clp: 0 }
			);
		},
		getValuesFromBaseStage(base_stage){
			return base_stage.items.reduce(
				(acc, item) => {
					const qty = Number(item.qty) || 0;
					acc.total_uf += (Number(item.unit_cost_uf) || 0) * qty;
					acc.total_clp += (Number(item.unit_cost_clp) || 0) * qty;
					return acc;
				},
				{ total_uf: 0, total_clp: 0 }
			);
		},
		addCategory(){
			this.costBaseCategories = {
				id: null,
				name: '',
				items: []
			}
			this.editCategoryName = true
		},
		addStage(cat_index, base_category_id){
			this.costBaseCategories[cat_index].base_stages
				.push({
					id: null,
					name: '',
					code: null,
					base_category_id,
					items:[{
						id: null,
						name: '',
						unit_cost_uf: null,
						unit_cost_clp: null
					}]
				})
		},
		addItem(cat_index, bp_index, base_stage_id){
			this.costBaseCategories[cat_index].base_stages[bp_index].items
				.push({
					id: null,
					name: '',
					unit_cost_uf: null,
					unit_cost_clp: null,
					base_stage_id
				})
		},
		blockDecimals(e) {
			if (e.key === '.' || e.key === ',' || e.key === 'e') {
				e.preventDefault()
			}
		},
		sanitizeIntegerInput(item) {
			item.unit_cost_clp = item.unit_cost_clp.replace(/\D/g, '') || null;
			this.setItemUfValueFromClp(item);
		},
		setItemClpValueFromUf(item) {
			const clp_value = item.unit_cost_uf * this.ufValue;
			item.unit_cost_clp = parseFloat(clp_value);
		},
		setItemUfValueFromClp(item) {
			const uf_value = item.unit_cost_clp / this.ufValue;
			item.unit_cost_uf = parseFloat(uf_value);
		},
		setCostProject(item){
			let data = {}
			if(item){
				data = {...data, ...item, ...{company_base_project_id: item.id}}
			}
			this.$store.commit('costbreakdown/setNewCostBreakdownBaseProjectModalEditing', data)
			this.$store.commit('costbreakdown/setNewCostBreakdownBaseProjectModal', true)
		},
		async deleteProject(item){
			await deleteCostBaseProject({company_base_project_id: item.id})
			this.$store.dispatch('costbreakdown/getCompanyBaseProjects')
		}
	}
}
</script>
<style>
	tr.no-hover-cells,
	tr.no-hover-cells td{
		background-color: inherit !important;
	}
	.custom-table-cost table {
		border-collapse: collapse;
	}
	.custom-table-cost table td{
		border: 1px solid #ccc;
	}
	.custom-table-cost table .main-row{
		border-top: 2px solid #bcbcbc;
		border-bottom: 2px solid #bcbcbc;
	}
	.custom-table-cost table .header-rows{
		background: rgb(120, 120, 120);
		color: white;
		font-size: 10px;
		font-weight: bold;
	}
	.custom-table-cost table tbody tr.header-rows td{
		height: 25px;
	}
	.custom-table-cost table .header-rows:hover{
		background: rgb(103, 103, 103) !important;
	}
</style>